import { useEffect } from "react";

interface InViewAnimationProps {
    animationElementsRef: React.RefObject<HTMLDivElement | HTMLAnchorElement | HTMLHeadingElement | null>[];
    animationClass: string;
    pageReady?: boolean;
}

const useInViewAnimation = ({animationElementsRef, animationClass, pageReady}: InViewAnimationProps) => {
    useEffect(() => {
        if (!pageReady) return;

        const handleScroll = () => {
            const windowHeight = window.innerHeight;

            animationElementsRef?.forEach((ref) => {
                const element = ref.current;
                if (!element) return;

                const elementTop = element.getBoundingClientRect().top;

                if ( elementTop < (windowHeight - 80) && !element.classList.contains(animationClass)) {
                    element.classList.add(animationClass);
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, [animationElementsRef, pageReady]);
};

export default useInViewAnimation;